module.exports = jwplayer;


//////////////////
// WEBPACK FOOTER
// external "jwplayer"
// module id = 1
// module chunks = 0 1 2 3 4 5 6